import { Controller } from 'react-hook-form'
import Layout from './Layout'
import * as Inputs from '@avcan/utils/dom/input'
import { UnsupportedDate } from '../../widgets/DateTime'
import styles from './Controls.module.css'

export default function Input({ register, name, label, description, input, ...props }) {
    const className = props.type === 'checkbox' ? styles.CheckboxLayout : null
    let child = null

    // Because, "enum" is a reserved word, I can not destructured it from and I do not want to pollute <input> with undesired props
    delete props.enum

    if (props.type === 'date' && !Inputs.isTypeSupported(props.type)) {
        child = <Controller name={name} as={<UnsupportedDate />} />
    }

    return (
        <Layout name={name} label={label} description={description} className={className}>
            {child || (
                <input
                    {...createExtraPropsFromOptions(input?.options, props.type)}
                    {...props}
                    name={name}
                    id={name}
                    ref={register}
                />
            )}
        </Layout>
    )
}

export function createProps({ type, format, minimum, maximum, pattern, minLength, maxLength }) {
    switch (type) {
        case 'integer':
            return {
                type: 'number',
                min: minimum,
                max: maximum,
                step: 1,
            }
        case 'boolean':
            return {
                type: 'checkbox',
            }
        case 'number':
            return {
                // Better to use defaults i.e. type="text"
                // type: 'number',
                // min: minimum,
                // max: maximum,
                // step: multipleOf,
            }
        case 'string':
            switch (format) {
                case 'date-time':
                    return {
                        type: 'datetime-local',
                    }
                case 'date':
                    return {
                        type: 'date',
                    }
                default:
                    return {
                        type: 'text',
                        pattern,
                        minLength,
                        maxLength,
                    }
            }
        default:
            return {}
    }
}

// Utils
export function createExtraPropsFromOptions(options, type) {
    if (typeof options !== 'object') {
        return {}
    }

    return Object.fromEntries(Object.entries(options).map(option => computeOption(option, type)))
}

function computeOption([key, values], type) {
    if (!Array.isArray(values)) {
        return [key, values]
    }

    return [
        key,
        values.reduce((value, operator) => {
            switch (operator) {
                case 'now': {
                    const now = new Date()

                    switch (type) {
                        case 'date':
                            return now.toISOString().substr(0, 10)
                        case 'date-time':
                            return now.toISOString()
                        default:
                            return value
                    }
                }
                default:
                    return value
            }
        }, null),
    ]
}
